module.exports = __webpack_public_path__ + "img/C4C6C6_4D5756_646463_7A8080-256px.9a319fdb.png";